export default {"src":"/_next/static/media/icon-double-left.92323e9f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};